module.exports = __webpack_public_path__ + "static/media/camera-lens-icon.9cfbfe1f.svg";